module.exports = __webpack_public_path__ + "static/media/removeIconBlue.df469f7c.png";